import "lib/@hooks/useEvent"
import { useReducer } from "react"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"
import { SaveDirtyChanged } from "../schedule-editor-event-definitions.mjs"

/**
 * Returns true while the schedule editor has unsaved local edits (autosave pending).
 * Reads `isSaveDirty` from the editor session, updated from ToBeSaved("schedule") in
 * schedule-editor.js so toolbar slot plugins re-render without prop drilling.
 *
 * @returns {boolean}
 */
export function useScheduleEditorSaveDirty() {
    const { draftId } = useScheduleEditorIds()
    const [, forceUpdate] = useReducer(tick, 0)

    SaveDirtyChanged(draftId).useEvent(forceUpdate)

    const session = readScheduleEditorSession(draftId)
    return Boolean(session?.isSaveDirty)
}

function tick(n) {
    return n + 1
}
